import { Component, OnInit, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { LegalLang } from '../../shared/legal-lang-toggle/legal-lang-toggle.component';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-privacy',
    templateUrl: './privacy.component.html',
    styleUrls: ['./privacy.component.scss'],
    standalone: false
})
export class PrivacyComponent implements OnInit, OnDestroy {

  // Local to this page — see LegalLangToggleComponent for why the app's LangService
  // is not used here.
  lang: LegalLang = 'en';

  constructor(private titleService: Title, private route: ActivatedRoute) { }

  ngOnInit() {
    document.body.classList.add('background');
    // Supports sharing a French link, e.g. /privacy?lang=fr
    if (this.route.snapshot.queryParamMap.get('lang') === 'fr') {
      this.lang = 'fr';
    }
    this.setTitle();
  }

  onLangChange(lang: LegalLang) {
    this.lang = lang;
    this.setTitle();
  }

  // Titled from the page's own language rather than the app's TranslateService,
  // so the toggle and the tab title cannot disagree.
  private setTitle() {
    const name = this.lang === 'fr' ? 'Politique de confidentialité' : 'Privacy Policy';
    this.titleService.setTitle(`${name} | ${environment.appName}`);
  }

  ngOnDestroy() {
    document.body.classList.remove('background');
  }

}
